import { render, staticRenderFns } from "./newscheck.vue?vue&type=template&id=3fea1da4&scoped=true&"
import script from "./newscheck.vue?vue&type=script&lang=js&"
export * from "./newscheck.vue?vue&type=script&lang=js&"
import style0 from "./newscheck.vue?vue&type=style&index=0&id=3fea1da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fea1da4",
  null
  
)

export default component.exports